<template>
  <div class="case">
    <banner img="../assets/img/banner.jpg" title="Game products" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div class="case-section-content-list" v-for="(cas,index) in caseList" :key="index">
          <img v-lazy="cas.img" />
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.title}}</p>
            <p class="abstract-content">{{cas.content}}</p>
            <div class="more">
                <span>more</span>
                <img class="moreBtn" src="../assets/img/sanjiao.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      caseList: [
		{
			id:1,
			title:'Hanging up in the Three Kingdoms',
			img:'https://qpyx-1301101041.cos.ap-guangzhou.myqcloud.com/2023/11/23/2cd82ebe4b9f4a3f9d092efd1c687ffc.png',
			content:"This product is a Qiqu Three Kingdoms themed card placement mobile game. The game features novel quirky battles, incorporating storyline missions of millionaires and random events, as well as innovative synthetic resource generation modes that enable resource visualization, enabling not only strategic operations but also casual hang ups."
		},
		{
			id:2,
			title:'Goddess Development Game',
			img:'https://qpyx-1301101041.cos.ap-guangzhou.myqcloud.com/2023/11/23/c0a2635ced5043909dc8835904d0be5a.jpg',
			content:"This product is a anime leisure mobile game. The game takes the Warring States Period as the background, turning many ancient military officers into various beautiful girls? Imperial Sister? Beast mother? Mechanical warfare? Everything! The game combines interactive development with combat adventure, with the core gameplay of multiple cute girls' lineups and unique hang up exploration, bringing players a brand new super casual placement experience!"
		},
		{
			id:3,
			title:'Theocratic game',
			img:'https://qpyx-1301101041.cos.ap-guangzhou.myqcloud.com/2023/11/23/e6f179e1445c4a009e694111094effda.jpg',
			content:"This product is a classic Oriental fantasy world! New PVP gameplay such as the Three Realms Battlefield, Peak Competition, Final Battle of the Imperial City, Cross server Siege, and more have become popular online! Super cool operating experience, stunning skill strike effects, and innovative real-time combat methods make you irresistible! More versatile warriors, powerful gods, cool appearance, cute and adorable pets in this world full of ultimate Eastern fantasy, waiting for your arrival!"
		},
		{
			id:4,
			title:'Swordsman World',
			img:'https://qpyx-korea-res-1300632903.cos.ap-seoul.myqcloud.com/2023/11/24/6f8f2bf50e764dc4b3c65c120b257cda.png',
			content:"This product is an innovative martial arts hedge combat system with a grand martial arts world view. It combines pre war skills with real-time magic weapon operations during battles, providing both strategic and thrilling combat experience."
		}
	]
    };
  },
  mounted() {
    // window.console.log("case");
    // this.$http
    //   .get("Cases/GetCasesAll")
    //   .then(response => {
    //     this.caseList = response.data;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
	this.loading = false;
  }
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #1667a0;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 40%;
          height: 80%;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              
            }
			.moreBtn {
				width: 12px;
				height: 12px;
			}
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
@media screen and (max-width: 500px) {
	.case{
		.banner{
			height: 20vh;
			
			::v-deep .banner-title{
				font-size: 1.4rem;
				line-height: 8rem; 
			}
		}
	}
	
	.case-section-content{
		width: 95%;
		.case-section-content-list{
			img{
				max-width: 100%;
				height: auto; /* 保持宽高比例 */
			}
			.content-list-abstract{
				width: 40%;
			}
		}
	}
	
}
</style>